// extracted by mini-css-extract-plugin
export default {"errorBox":"errorBox__errorBox--p_GCN","title":"errorBox__title--SFH22","message":"errorBox__message--j6_mn","button":"errorBox__button--GN2Gq"};